var array = Array.prototype;

export var map = array.map;
export var slice = array.slice;



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-scale/src/array.js
// module id = XrLQ
// module chunks = 0